import { createIcon } from '@chakra-ui/icons'

// using `path`
export const ProblemSolvingIcon = createIcon({
  displayName: 'ProblemSolvingIcon',
  viewBox:"0, 0, 800,800",

  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: (<g transform="translate(0.000000,700.000000) scale(0.100000,-0.100000)"
  fill="black" stroke="none">
  <path d="M3445 6755 c-25 -24 -25 -27 -25 -193 0 -163 1 -169 23 -190 32 -30
  87 -29 115 1 21 22 22 33 22 191 0 164 0 167 -25 191 -15 16 -36 25 -55 25
  -19 0 -40 -9 -55 -25z"/>
  <path d="M2468 6501 c-22 -11 -36 -27 -42 -48 -8 -29 -2 -44 64 -160 89 -158
  102 -173 151 -173 43 0 79 35 79 78 0 26 -138 280 -162 299 -25 19 -57 21 -90
  4z"/>
  <path d="M4475 6512 c-11 -2 -26 -9 -33 -14 -24 -20 -162 -274 -162 -300 0
  -43 36 -78 79 -78 49 0 62 15 151 172 60 106 71 132 65 157 -3 16 -12 34 -18
  40 -20 16 -61 28 -82 23z"/>
  <path d="M3360 6023 c-69 -7 -235 -45 -304 -70 -461 -166 -799 -576 -871
  -1058 -8 -55 -15 -126 -15 -157 l0 -58 215 0 c216 0 216 0 240 -25 33 -32 31
  -64 -5 -128 -81 -144 6 -307 163 -307 64 0 105 19 149 68 59 65 65 166 14 242
  -33 50 -34 93 -1 125 l24 25 226 0 225 0 0 138 0 137 -98 0 c-90 0 -103 3
  -164 33 -283 139 -270 530 22 665 35 16 66 21 143 21 l97 1 -2 174 c-2 106 -7
  175 -13 176 -5 1 -26 0 -45 -2z"/>
  <path d="M3586 6022 c-3 -3 -6 -123 -6 -267 0 -260 0 -262 -23 -283 -32 -30
  -78 -28 -129 6 -36 23 -52 27 -114 27 -65 0 -76 -3 -111 -31 -70 -56 -101
  -155 -72 -231 13 -35 64 -90 102 -110 50 -25 130 -19 192 16 66 37 98 39 130
  6 l25 -24 0 -226 0 -225 138 0 137 0 0 98 c1 86 4 104 29 156 53 109 149 182
  272 206 154 30 322 -59 392 -208 24 -50 27 -70 27 -154 l0 -98 128 0 127 0 0
  58 c0 162 -54 372 -139 547 -181 369 -519 633 -916 713 -116 24 -181 32 -189
  24z"/>
  <path d="M1740 5777 c-49 -25 -61 -95 -22 -130 10 -9 73 -47 140 -86 141 -81
  177 -88 211 -45 24 31 27 71 7 100 -17 23 -274 174 -297 174 -8 0 -25 -6 -39
  -13z"/>
  <path d="M5075 5716 c-71 -42 -138 -85 -147 -97 -24 -28 -23 -70 3 -103 34
  -43 70 -36 211 45 67 39 132 79 143 89 25 26 25 84 -1 110 -42 42 -69 36 -209
  -44z"/>
  <path d="M4140 4964 c-113 -49 -153 -178 -90 -291 37 -66 38 -102 4 -134 -25
  -24 -28 -24 -250 -27 l-224 -3 0 -135 0 -135 63 7 c124 13 260 -46 332 -144
  135 -185 73 -444 -132 -548 -53 -26 -67 -29 -160 -29 l-103 0 0 -302 0 -303
  358 0 359 0 6 98 c15 226 78 494 160 680 25 56 86 174 137 262 50 88 107 193
  125 233 35 75 77 211 88 279 l6 37 -211 3 -210 3 -24 28 c-31 36 -30 73 3 122
  48 71 44 180 -10 242 -59 67 -151 90 -227 57z"/>
  <path d="M2187 4473 c11 -69 53 -205 88 -280 19 -41 76 -147 126 -236 51 -88
  112 -205 136 -260 82 -185 143 -445 160 -682 l8 -100 355 0 355 0 5 398 5 399
  24 19 c31 26 69 24 112 -5 46 -31 112 -49 152 -41 157 34 219 212 115 330 -61
  70 -178 84 -258 31 -50 -33 -99 -34 -128 -3 -21 22 -22 31 -22 245 l0 222
  -137 0 -138 0 0 -93 c0 -78 -4 -101 -27 -149 -37 -79 -98 -142 -177 -181 -59
  -29 -74 -32 -156 -32 -82 0 -97 3 -156 32 -79 39 -140 102 -177 181 -23 49
  -27 70 -27 149 l0 93 -122 0 -122 0 6 -37z"/>
  <path d="M2710 2700 c0 -88 38 -152 115 -193 40 -22 44 -22 675 -22 631 0 635
  0 675 22 77 41 115 105 115 193 l0 50 -790 0 -790 0 0 -50z"/>
  <path d="M2930 2277 c0 -93 45 -166 124 -203 l51 -24 395 0 c245 0 409 4 433
  11 81 22 144 107 149 200 l3 54 -577 3 -578 2 0 -43z"/>
  <path d="M3150 1844 c0 -88 48 -167 123 -203 39 -19 61 -21 230 -21 147 0 196
  3 225 16 79 33 132 110 132 194 l0 50 -355 0 -355 0 0 -36z"/>
  <path d="M793 733 c-31 -6 -70 -49 -75 -81 -11 -76 35 -132 108 -132 54 0 74
  8 74 30 0 14 -7 16 -49 12 -42 -4 -50 -1 -65 19 -23 33 -20 66 10 95 25 25 39
  27 88 8 11 -4 16 0 16 14 0 12 -3 23 -8 26 -13 8 -76 14 -99 9z"/>
  
  
  
 
  
 
 
  
  </g>
    
  ),
})
